module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_1.9acf7df1.png";